<script>
  import { onMount } from 'svelte';
  import { authorize, authorized } from './auth.js';
  import { api_url } from './config.js';
  import Modal from './Modal.svelte';

  //draft state
  let email_address = "";
  let template_body_plain = "";
  let show_modal = false;
  let has_attempted_submission = false;

  //network state
  let sending = false;
  let error = false;
  let success = false;
  $: !show_modal && (success = false);

  const handleSubmit = async (e, attempt = 0) => {
    console.log("attempting");
    has_attempted_submission = true;
    sending = true;
    error = false;
    success = false;
    let send_response = await fetch(`${api_url}/edge-alert-subscribe-user`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
        "Authorization": `Bearer ${$authorized}`
      },
      body: JSON.stringify({
        email_address,
      }),
    });
    //handle 401 UNAUTHORIZED
    if (send_response.status === 401) {
      await authorize();
      if ($authorized) {
        if (attempt === 0) return handleSubmit(e, attempt + 1);
        else {
          authorized.set(false);
          return;
        }
      } else {
        authorized.set(false);
        error = true;
        sending = false;
        return;
      };
    } else if (!send_response.ok) {
      //some other error
      let response_text = await send_response.text();
      console.error(response_text)
      error = true;
      sending = false;
    }
    //reset state
    email_address = "";
    sending = false;
    success = true;
    has_attempted_submission = false;
  }

  const handleKeypress = e => {
    if (e.keyCode === 13) {
      e.stopPropagation();
      e.preventDefault();
    }
  }

</script>

<section>
  <h2>Subscribe a User</h2>
  <form on:submit|preventDefault={() => (has_attempted_submission = true) && (show_modal = true)}>
    <div class="subject">
      <label for="subscribe_email">Email</label>
      <input id="subscribe_email" class:invalid={has_attempted_submission} on:keypress={handleKeypress} bind:value={email_address}/>
    </div>
    <input
      type="submit"
      value="Subscribe"
      class="submit subscribe"
    />
  </form>
  <Modal bind:show={show_modal}>
    <div class="modal-content" on:click|stopPropagation>
      {#if !success && !sending}
        <h2>Confirmation</h2>
        <p><span class="blue">Subscribe</span> user {email_address}?</p>
        <button
          class="submit"
          on:click={handleSubmit}
        >
          Confirm
        </button>
        <div class="cancel" on:click={() => show_modal = false}>Cancel</div>
      {:else if success}
        <h2>Subscribe successful.</h2>
        <button class="back" on:click={() => show_modal = false}>Close</button>
      {:else if sending}
        <h1>Processing...</h1>
      {/if}
    </div>
  </Modal>
</section>

<style>
  button.back {
    background-color: #103462;
    width: auto;
    display: block;
    margin: 16px auto 0px;
    padding: 14px;
  }

  label {
    font-size: 16px;
    line-height: 19px;
    font-weight: 600;
    text-align: left;
    margin-bottom: 8px;
    margin-top: 8px;
  }

  h2 {
    margin: 0px;
    margin-top: 27px;
    font-size: 1.5em;
  }

  section {
    padding: 1em 16px;
    margin: auto;
    width: 100%;
    max-width: 752px;
    box-sizing: border-box;
  }

  p {
    padding: 25px 0 25px;
    line-height: 22px;
    font-size: 16px;
    margin: 0;
  }

  form {
    max-width: 100%;
  }

  input, textarea {
    width: 100%;
    display: block;
    padding: 11px 15px;
    color: #222;
    line-height: 22px;
    font-weight: 300;
  }

  textarea {
    resize: vertical;
    height: 500px;
    min-height: 2em;
    letter-spacing: -0.25px;
    text-align: left;
  }

  .cancel {
    color: #C20017;
    text-decoration: underline;
    margin: 8px auto 0px;
    padding: 3px;
    width: max-content;
  }

  .cancel:hover {
    cursor: pointer;
  }

  .modal-content {
    border-radius: 4px;
    padding: 21px 48px;
    position: relative;
    background-color: white;
    opacity: 1.0;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    min-height: 284px;
    width: 504px;
    max-width: 90%;
    text-align: left;
    box-sizing: border-box;
    font-size: 0.9rem;
  }

  .subject {
    width: 100%;
    position: relative;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 4px;
  }

  .submit {
    height: 44px;
    border-radius: 4px;
    width: 100%;
    background-color: #437322;
    color: white;
    margin-top: 6px;
    font-weight: 400;
  }

  .submit.subscribe {
    background-color: #003366;
  }

  .blue {
    color: #003366;
    text-decoration: bold;
  }

  .submit:active {
    box-shadow: 2px 2px 2px black inset;
  }

  .invalid {
    box-shadow: 0 0 1px 1px #C20017;
  }

  #form_header {
    margin-top: 32px;
  }

  #subject {
    height: 46px;
  }
</style>
